
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import Constant from '../../../common/constant/Constant';
import { getPanelType } from '../handler/CreateTicketCommonHandler';
import { PropTypes } from 'prop-types';

export const DialogConfirmCancelCreateTicket = props => {
    let msgDisplay = I18n.get('MSG-CM-CONFIRM-CANCEL-DATA-CHANGE');
    let labelCancel = I18n.get('CM-BUTTON-OK');
    let labelClose = I18n.get('CM-BUTTON-CANCEL');
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmCancelCreateTicket(false);
    };

    const onHandlerCancelCreateTicket = () => {
        props.setIsConfirmCancelCreateTicket(false);
        if(props?.setHandleStatus) {
            props?.setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_INITIAL);
        }
        props.closePanelTab({
            event: null,
            panelType: getPanelType(props.panelList, props.panelId),
            panelId: props.panelId,
            tabId: props.tabId
        });

        if (props?.removePanelInitData && props?.panelInitData && props?.setPanelInitData) {
            props?.removePanelInitData(props?.panelId, props?.tabId, props?.panelInitData, props?.setPanelInitData);
        }
    };

    return (
        <Dialog
            open={props.isConfirmCancelCreateTicket}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">{msgDisplay}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={onHandlerCancelCreateTicket}
                >
                    {labelCancel}
                </Button>
                <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {labelClose}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogConfirmCancelCreateTicket.propTypes = {
    isConfirmCancelCreateTicket: PropTypes.any,
    setIsConfirmCancelCreateTicket: PropTypes.any,
    setHandleStatus: PropTypes.any,
    closePanelTab: PropTypes.any,
    panelList: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    removePanelInitData: PropTypes.any,
    panelInitData: PropTypes.any,
    setPanelInitData: PropTypes.any
};